module.exports = __webpack_public_path__ + "img/f868100.png";